import { render, staticRenderFns } from "./AssetsBase.vue?vue&type=template&id=4f870732"
import script from "./AssetsBase.vue?vue&type=script&lang=js"
export * from "./AssetsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports